// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Color definitions for the app
 */

.Field {
  position: relative;
  font-size: 12px;
}
.Field .field-label {
  display: inline-flex;
  align-items: center;
  height: 12px;
  font-size: 10px;
  font-weight: normal;
  line-height: 1.2;
  letter-spacing: 0.67px;
  white-space: nowrap;
  color: #959AAD;
  margin-bottom: 8px;
  text-transform: uppercase;
  user-select: none;
}
.Field .field-label.required::after {
  content: "";
  width: 4px;
  height: 4px;
  margin-left: 4px;
  background: #F66733;
  border-radius: 50%;
}
.Field > .help-text {
  margin-top: 8px;
  color: #959AAD;
  font-size: 10px;
  font-weight: bold;
}
.Field .input-container,
.Field .select-container {
  position: relative;
}
.Field .input-container > .custom-button,
.Field .select-container > .custom-button {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #FFFFFF;
}
.Field .input-container > .inner-label,
.Field .select-container > .inner-label {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: absolute;
  color: #D0D5DD;
  top: 1px;
  right: 1px;
  background-color: #FFFFFF;
  height: calc(100% - 2px);
  border-left: 1px solid #E1E1E9;
  padding: 0 16px;
}
.Field .input-container > .multiple-values-container,
.Field .select-container > .multiple-values-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  max-width: calc(100% - 40px);
  padding-left: 8px;
  padding-right: 32px;
  overflow: hidden;
}
.Field .input-container > .multiple-values-container .multiple-values,
.Field .select-container > .multiple-values-container .multiple-values {
  display: flex;
  align-items: center;
  height: 24px;
  padding: 0 8px;
  background-color: rgba(51, 63, 72, 0.16);
  color: #333F48;
  border-radius: 4px;
}
.Field .input-container > .multiple-values-container .multiple-values > .text,
.Field .select-container > .multiple-values-container .multiple-values > .text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.Field .select-container select {
  width: 100%;
  height: 32px;
  box-sizing: border-box;
  padding: 0 8px;
  padding-right: 32px;
  border: 1px solid #E1E1E9;
  border-radius: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  appearance: none;
}
.Field .select-container select.disabled {
  background-color: light-dark(rgba(239, 239, 239, 0.3), rgba(59, 59, 59, 0.3));
  color: light-dark(rgb(84, 84, 84), rgb(170, 170, 170));
}
.Field .select-container select option:disabled {
  color: rgba(149, 154, 173, 0.5);
}
.Field .select-container ::-ms-expand {
  display: none;
}
.Field .select-container .arrow-down {
  position: absolute;
  right: 8px;
  top: 8px;
  pointer-events: none;
}
.Field .select-container .select-placeholder {
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-right: 32px;
  background-color: transparent;
  border: none;
}
.Field .select-container .MuiInputBase-root {
  width: 100%;
}
.Field .field-input,
.Field .field-textarea {
  width: 100%;
  height: 32px;
  box-sizing: border-box;
  padding: 8px;
  border: 1px solid #E1E1E9;
  font-family: "Lato", sans-serif;
  border-radius: 4px;
}
.Field .field-input.mui-select,
.Field .field-textarea.mui-select {
  height: 32px;
}
.Field .field-input.has-button,
.Field .field-textarea.has-button {
  width: calc(100% - 28px);
}
.Field .field-input:focus,
.Field .field-textarea:focus {
  outline: none;
  border: 1px solid #333F48;
}
.Field .field-input::placeholder,
.Field .field-textarea::placeholder {
  color: #959AAD;
}
.Field .field-input {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.Field .field-textarea {
  min-height: 64px;
  resize: vertical;
}
.Field .input-group-right {
  position: absolute;
  top: 0;
  height: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  box-sizing: border-box;
  pointer-events: none;
}
.Field .field-errors {
  margin-top: 5px;
  font-size: 10px;
  color: #CF0838;
  text-align: left;
}
.Field.has-error .field-label {
  color: #CF0838;
}
.Field.has-error .field-input,
.Field.has-error .field-textarea {
  color: #CF0838;
  border: 1px solid #CF0838;
}
.Field.has-error .field-input::placeholder,
.Field.has-error .field-textarea::placeholder {
  color: rgba(207, 8, 56, 0.75);
}
.Field .datepicker-container {
  position: relative;
}
.Field .datepicker-container .react-datepicker-wrapper {
  width: 100%;
}
.Field .datepicker-container .datepicker-icon {
  position: absolute;
  top: calc(50% - 8px);
  left: 8px;
  z-index: 2;
}
.Field .datepicker-container .datepicker-input {
  padding-left: 32px;
}
.Field .datepicker-container .datepicker-close {
  position: absolute;
  top: calc(50% - 8px);
  right: 8px;
  z-index: 2;
}

.SelectPopoverRoot {
  z-index: 1301 !important;
}`, "",{"version":3,"sources":["webpack://./src/vibeguide/src/sass/color.scss","webpack://./src/vibeguide/src/components/Field/Field.scss"],"names":[],"mappings":"AAAA;;EAAA;;ACEA;EAEE,kBAAA;EACA,eAAA;AAuFF;AArFE;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,cDHM;ECIN,kBAAA;EACA,yBAAA;EACA,iBAAA;AAuFJ;AAnFM;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,mBDlBC;ECmBD,kBAAA;AAqFR;AAhFE;EACE,eAAA;EACA,cDvBM;ECwBN,eAAA;EACA,iBAAA;AAkFJ;AA/EE;;EAEE,kBAAA;AAiFJ;AA/EI;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,yBD3BE;AC6GR;AA/EI;;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cDuBI;ECtBJ,QAAA;EACA,UAAA;EACA,yBDvCE;ECwCF,wBAAA;EACA,8BAAA;EACA,eAAA;AAkFN;AA/EI;;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,4BAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAkFN;AAhFM;;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,wCDpCI;ECqCJ,cDjFE;ECkFF,kBAAA;AAmFR;AAjFQ;;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAoFV;AA5EI;EAEE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EAEA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AA4EN;AA1EM;EACE,6EAAA;EACA,sDAAA;AA4ER;AAzEM;EACE,+BDzDI;ACoIZ;AAvEI;EACE,aAAA;AAyEN;AAtEI;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,oBAAA;AAwEN;AArEI;EACE,oBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,6BAAA;EACA,YAAA;AAuEN;AApEI;EACE,WAAA;AAsEN;AAlEE;;EAEE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,+BAAA;EACA,kBAAA;AAoEJ;AAlEI;;EACE,YAAA;AAqEN;AAlEI;;EACE,wBAAA;AAqEN;AA/DI;;EACE,aAAA;EACA,yBAAA;AAkEN;AA/DI;;EACE,cDvKI;ACyOV;AA9DE;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAgEJ;AA7DE;EACE,gBAAA;EAEA,gBAAA;AA8DJ;AA3DE;EACE,kBAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;EACA,+BAAA;EACA,sBAAA;EACA,oBAAA;AA6DJ;AA1DE;EACE,eAAA;EACA,eAAA;EACA,cDlMI;ECmMJ,gBAAA;AA4DJ;AAvDI;EACE,cDzME;ACkQR;AAtDI;;EAEE,cD9ME;EC+MF,yBAAA;AAwDN;AAtDM;;EACE,6BD1JE;ACmNV;AApDE;EACE,kBAAA;AAsDJ;AAnDI;EACE,WAAA;AAqDN;AAlDI;EACE,kBAAA;EACA,oBAAA;EACA,SAAA;EACA,UAAA;AAoDN;AAjDI;EACE,kBAAA;AAmDN;AAhDI;EACE,kBAAA;EACA,oBAAA;EACA,UAAA;EACA,UAAA;AAkDN;;AA7CA;EACE,wBAAA;AAgDF","sourcesContent":["/**\n * Color definitions for the app\n */\n\n// Theme Colors\n$primary: #333F48;\n$secondary: #222732;\n$yellow: #FECF0C;\n$red: #E02D4F;\n$teal: #23CCC3;\n$orange: #F66733;\n$lightGray: #F6F6F6;\n$whiteSmoke: #E1E1E9;\n$manatee: #959AAD;\n$obsidian: #383838;\n\n// Status Colors\n$success: #00A474;\n$warning: #FFC107;\n$error: #CF0838;\n\n// Other Colors\n$white: #FFFFFF;\n$black: #000000;\n$gray: #757575;\n$darkGray: #A4A7B7;\n$mediumGray: #E0E0E0;\n$lighterGray: #E3E7F4;\n$lightSlateGray: #8A8FA3;\n$carrot: #FF892E;\n$lightSmoke: #F5F4F5;\n$graphBlue: #1570EF;\n$lightOrchid: #7F56D9;\n$rainboots: #3361E1;\n$royalBlue: #4085DE;\n$sushi: #95C653;\n\n// Component Colors\n$primaryButtonBackground: $yellow;\n$primaryButtonText: $primary;\n$secondaryButtonBackground: $primary;\n$secondaryButtonText: $white;\n$navigationText: #95A3AD;\n$scheduleMusic: #FCC7B3;\n$scheduleMessageBlock: $teal;\n$scheduleInterrupt: #1997A3;\n$scheduleLoop: $primary;\n\n// Variants: Theme Colors\n$primary16: rgba($primary, 0.16);\n$primary40: rgba($primary, 0.4);\n$primary50: rgba($primary, 0.5);\n$primary60: rgba($primary, 0.6);\n$secondary25: rgba($secondary, 0.25);\n$secondary50: rgba($secondary, 0.5);\n$secondary75: rgba($secondary, 0.75);\n$yellow16: rgba($yellow, 16%);\n$yellow25: rgba($yellow, 25%);\n$yellow75: rgba($yellow, 75%);\n$orange16: rgba($orange, 0.16);\n$orange32: rgba($orange, 0.32);\n$orange50: rgba($orange, 0.5);\n$orange75: rgba($orange, 0.75);\n$manatee16: rgba($manatee, 0.16);\n$manatee50: rgba($manatee, 0.5);\n\n// Variants: Status Colors\n$success10: rgba($success, 0.08);\n$success16: rgba($success, 0.16);\n$success75: rgba($success, 0.75);\n$warning50: rgba($warning, 0.5);\n$error10: rgba($error, 0.1);\n$error16: rgba($error, 0.16);\n$error20: rgba($error, 0.2);\n$error50: rgba($error, 0.5);\n$error75: rgba($error, 0.75);\n$error85: rgba($error, 0.85);\n\n// Variants: Other Colors\n$gray50: #F9FAFB;\n$gray200: #EAECF0;\n$gray300: #D0D5DD;\n$gray400: #98A2B3;\n$gray500: #667085;\n$gray700: #344054;\n$gray900: #101828;\n$carrot16: rgba($carrot, 0.16);\n$rainboots16: rgba($rainboots, 0.16);\n$royalBlue16: rgba($royalBlue, 0.16);\n\n// Box colors (for color picker)\n$boxRed: $red;\n$boxPink: #F57A7A;\n$boxOrange: $orange;\n$boxYellow: $yellow;\n$boxGreen: #95C653;\n$boxDarkGreen: #00A474;\n$boxBlue: #33ACE1;\n$boxDarkBlue: #3361E1;\n$boxPurple: #6D6DB5;\n$boxPurple16: rgba($boxPurple, 0.16);\n$boxDarkPurple: #332A4B;\n\n:export {\n  // Theme Colors\n  primary: $primary;\n  secondary: $secondary;\n  yellow: $yellow;\n  red: $red;\n  teal: $teal;\n  orange: $orange;\n  lightGray: $lightGray;\n  whiteSmoke: $whiteSmoke;\n  manatee: $manatee;\n  obsidian: $obsidian;\n\n  // Status Colors\n  success: $success;\n  warning: $warning;\n  error: $error;\n\n  // Other Colors\n  white: $white;\n  black: $black;\n  gray: $gray;\n  darkGray: $darkGray;\n  mediumGray: $mediumGray;\n  lighterGray: $lighterGray;\n  lightSlateGray: $lightSlateGray;\n  carrot: $carrot;\n  lightSmoke: $lightSmoke;\n  graphBlue: $graphBlue;\n  lightOrchid: $lightOrchid;\n  rainboots: $rainboots;\n  royalBlue: $royalBlue;\n  sushi: $sushi;\n\n  // Component Colors\n  primaryButtonBackground: $primaryButtonBackground;\n  primaryButtonText: $primaryButtonText;\n  secondaryButtonBackground: $secondaryButtonBackground;\n  secondaryButtonText: $secondaryButtonText;\n  navigationText: $navigationText;\n  scheduleMusic: $scheduleMusic;\n  scheduleMessageBlock: $scheduleMessageBlock;\n  scheduleInterrupt: $scheduleInterrupt;\n  scheduleLoop: $scheduleLoop;\n  \n  // Variants: Theme Colors\n  primary16: $primary16;\n  primary40: $primary40;\n  primary50: $primary50;\n  primary60: $primary60;\n  secondary25: $secondary25;\n  secondary50: $secondary50;\n  secondary75: $secondary75;\n  yellow16: $yellow16;\n  yellow25: $yellow25;\n  yellow75: $yellow75;\n  orange16: $orange16;\n  orange32: $orange32;\n  orange50: $orange50;\n  orange75: $orange75;\n  manatee16: $manatee16;\n  manatee50: $manatee50;\n\n  // Variants: Status Colors\n  success10: $success10;\n  success16: $success16;\n  success75: $success75;\n  warning50: $warning50;\n  error10: $error10;\n  error16: $error16;\n  error20: $error20;\n  error50: $error50;\n  error75: $error75;\n  error85: $error85;\n\n  // Variants: Other Colors\n  gray50: $gray50;\n  gray200: $gray200;\n  gray300: $gray300;\n  gray400: $gray400;\n  gray500: $gray500;\n  gray700: $gray700;\n  gray900: $gray900;\n  carrot16: $carrot16;\n  rainboots16: $rainboots16;\n  royalBlue16: $royalBlue16;\n  boxPurple16: $boxPurple16;\n\n  // Box colors (for color picker)\n  boxRed: $boxRed;\n  boxPink: $boxPink;\n  boxOrange: $boxOrange;\n  boxYellow: $boxYellow;\n  boxGreen: $boxGreen;\n  boxDarkGreen: $boxDarkGreen;\n  boxBlue: $boxBlue;\n  boxDarkBlue: $boxDarkBlue;\n  boxPurple: $boxPurple;\n  boxDarkPurple: $boxDarkPurple;\n}\n","@use '../../sass/color.scss' as color;\n\n.Field {\n  // user-select: none;\n  position: relative;\n  font-size: 12px;\n\n  .field-label {\n    display: inline-flex;\n    align-items: center;\n    height: 12px;\n    font-size: 10px;\n    font-weight: normal;\n    line-height: 1.2;\n    letter-spacing: 0.67px;\n    white-space: nowrap;\n    color: color.$manatee;\n    margin-bottom: 8px;\n    text-transform: uppercase;\n    user-select: none;\n\n    &.required {\n  \n      &::after {\n        content: '';\n        width: 4px;\n        height: 4px;\n        margin-left: 4px;\n        background: color.$orange;\n        border-radius: 50%;\n      }\n    }\n  }\n\n  > .help-text {\n    margin-top: 8px;\n    color: color.$manatee;\n    font-size: 10px;\n    font-weight: bold;\n  }\n\n  .input-container,\n  .select-container {\n    position: relative;\n\n    > .custom-button {\n      position: absolute;\n      top: 0;\n      right: 0;\n      background-color: color.$white;\n    }\n\n    > .inner-label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      text-align: center;\n      position: absolute;\n      color: color.$gray300;\n      top: 1px;\n      right: 1px;\n      background-color: color.$white;\n      height: calc(100% - 2px);\n      border-left: 1px solid color.$whiteSmoke;\n      padding: 0 16px;\n    }\n\n    > .multiple-values-container {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      position: absolute;\n      top: 0;\n      left: 0;\n      height: 100%;\n      max-width: calc(100% - 40px);\n      padding-left: 8px;\n      padding-right: 32px;\n      overflow: hidden;\n\n      .multiple-values {\n        display: flex;\n        align-items: center;\n        height: 24px;\n        padding: 0 8px;\n        background-color: color.$primary16;\n        color: color.$primary;\n        border-radius: 4px;\n\n        > .text {\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n      }\n    }\n  }\n\n  .select-container {\n    // background: color.$white;\n    select {\n      // background: transparent;\n      width: 100%;\n      height: 32px;\n      box-sizing: border-box;\n      padding: 0 8px;\n      padding-right: 32px;\n      border: 1px solid color.$whiteSmoke;\n      border-radius: 4px;\n      // color: color.$obsidian;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      appearance: none;\n\n      &.disabled {\n        background-color: light-dark(rgba(239, 239, 239, 0.3), rgba(59, 59, 59, 0.3));\n        color: light-dark(rgb(84, 84, 84), rgb(170, 170, 170));\n      }\n\n      option:disabled {\n        color: color.$manatee50;\n      }\n    }\n\n    ::-ms-expand {\n      display: none;\n    }\n\n    .arrow-down {\n      position: absolute;\n      right: 8px;\n      top: 8px;\n      pointer-events: none;\n    }\n\n    .select-placeholder {\n      pointer-events: none;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      padding-right: 32px;\n      background-color: transparent;\n      border: none;\n    }\n\n    .MuiInputBase-root {\n      width: 100%;\n    }\n  }\n\n  .field-input,\n  .field-textarea {\n    width: 100%;\n    height: 32px;\n    box-sizing: border-box;\n    padding: 8px;\n    border: 1px solid color.$whiteSmoke;\n    font-family: 'Lato', sans-serif;\n    border-radius: 4px;\n\n    &.mui-select {\n      height: 32px;\n    }\n\n    &.has-button {\n      width: calc(100% - 28px);\n    }\n\n    // &.disabled {\n    //   background-color: color.$manatee16;\n    // }\n    &:focus {\n      outline: none;\n      border: 1px solid color.$primary;\n    }\n\n    &::placeholder {\n      color: color.$manatee;\n    }\n  }\n\n  .field-input {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .field-textarea {\n    min-height: 64px;\n    // only allow browser vertical resizing\n    resize: vertical;\n  }\n\n  .input-group-right {\n    position: absolute;\n    top: 0;\n    height: 32px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n    box-sizing: border-box;\n    pointer-events: none;\n  }\n\n  .field-errors {\n    margin-top: 5px;\n    font-size: 10px;\n    color: color.$error;\n    text-align: left;\n  }\n\n  &.has-error {\n\n    .field-label {\n      color: color.$error;\n    }\n\n    .field-input,\n    .field-textarea {\n      color: color.$error;\n      border: 1px solid color.$error;\n\n      &::placeholder {\n        color: color.$error75;\n      }\n    }\n  }\n\n  .datepicker-container {\n    position: relative;\n\n    // Override the datepicker to extend to the full width of the container\n    .react-datepicker-wrapper {\n      width: 100%;\n    }\n\n    .datepicker-icon {\n      position: absolute;\n      top: calc(50% - 8px);\n      left: 8px;\n      z-index: 2;\n    }\n\n    .datepicker-input {\n      padding-left: 32px;\n    }\n\n    .datepicker-close {\n      position: absolute;\n      top: calc(50% - 8px);\n      right: 8px;\n      z-index: 2;\n    }\n  }\n}\n\n.SelectPopoverRoot {\n  z-index: 1301 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export var primary = `#333F48`;
export var secondary = `#222732`;
export var yellow = `#FECF0C`;
export var red = `#E02D4F`;
export var teal = `#23CCC3`;
export var orange = `#F66733`;
export var lightGray = `#F6F6F6`;
export var whiteSmoke = `#E1E1E9`;
export var manatee = `#959AAD`;
export var obsidian = `#383838`;
export var success = `#00A474`;
export var warning = `#FFC107`;
export var error = `#CF0838`;
export var white = `#FFFFFF`;
export var black = `#000000`;
export var gray = `#757575`;
export var darkGray = `#A4A7B7`;
export var mediumGray = `#E0E0E0`;
export var lighterGray = `#E3E7F4`;
export var lightSlateGray = `#8A8FA3`;
export var carrot = `#FF892E`;
export var lightSmoke = `#F5F4F5`;
export var graphBlue = `#1570EF`;
export var lightOrchid = `#7F56D9`;
export var rainboots = `#3361E1`;
export var royalBlue = `#4085DE`;
export var sushi = `#95C653`;
export var primaryButtonBackground = `#FECF0C`;
export var primaryButtonText = `#333F48`;
export var secondaryButtonBackground = `#333F48`;
export var secondaryButtonText = `#FFFFFF`;
export var navigationText = `#95A3AD`;
export var scheduleMusic = `#FCC7B3`;
export var scheduleMessageBlock = `#23CCC3`;
export var scheduleInterrupt = `#1997A3`;
export var scheduleLoop = `#333F48`;
export var primary16 = `rgba(51, 63, 72, 0.16)`;
export var primary40 = `rgba(51, 63, 72, 0.4)`;
export var primary50 = `rgba(51, 63, 72, 0.5)`;
export var primary60 = `rgba(51, 63, 72, 0.6)`;
export var secondary25 = `rgba(34, 39, 50, 0.25)`;
export var secondary50 = `rgba(34, 39, 50, 0.5)`;
export var secondary75 = `rgba(34, 39, 50, 0.75)`;
export var yellow16 = `rgba(254, 207, 12, 0.16)`;
export var yellow25 = `rgba(254, 207, 12, 0.25)`;
export var yellow75 = `rgba(254, 207, 12, 0.75)`;
export var orange16 = `rgba(246, 103, 51, 0.16)`;
export var orange32 = `rgba(246, 103, 51, 0.32)`;
export var orange50 = `rgba(246, 103, 51, 0.5)`;
export var orange75 = `rgba(246, 103, 51, 0.75)`;
export var manatee16 = `rgba(149, 154, 173, 0.16)`;
export var manatee50 = `rgba(149, 154, 173, 0.5)`;
export var success10 = `rgba(0, 164, 116, 0.08)`;
export var success16 = `rgba(0, 164, 116, 0.16)`;
export var success75 = `rgba(0, 164, 116, 0.75)`;
export var warning50 = `rgba(255, 193, 7, 0.5)`;
export var error10 = `rgba(207, 8, 56, 0.1)`;
export var error16 = `rgba(207, 8, 56, 0.16)`;
export var error20 = `rgba(207, 8, 56, 0.2)`;
export var error50 = `rgba(207, 8, 56, 0.5)`;
export var error75 = `rgba(207, 8, 56, 0.75)`;
export var error85 = `rgba(207, 8, 56, 0.85)`;
export var gray50 = `#F9FAFB`;
export var gray200 = `#EAECF0`;
export var gray300 = `#D0D5DD`;
export var gray400 = `#98A2B3`;
export var gray500 = `#667085`;
export var gray700 = `#344054`;
export var gray900 = `#101828`;
export var carrot16 = `rgba(255, 137, 46, 0.16)`;
export var rainboots16 = `rgba(51, 97, 225, 0.16)`;
export var royalBlue16 = `rgba(64, 133, 222, 0.16)`;
export var boxPurple16 = `rgba(109, 109, 181, 0.16)`;
export var boxRed = `#E02D4F`;
export var boxPink = `#F57A7A`;
export var boxOrange = `#F66733`;
export var boxYellow = `#FECF0C`;
export var boxGreen = `#95C653`;
export var boxDarkGreen = `#00A474`;
export var boxBlue = `#33ACE1`;
export var boxDarkBlue = `#3361E1`;
export var boxPurple = `#6D6DB5`;
export var boxDarkPurple = `#332A4B`;
export default ___CSS_LOADER_EXPORT___;
